import React from "react";

export const BackIcon = () => {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight: 10 }}
    >
      <path
        d="M0 7L4.72727 0.5H8L3.27273 7L8 13.5H4.72727L0 7Z"
        fill="#ffffff"
      />
    </svg>
  );
};

export default React.memo(BackIcon);
